import { Component, Host, HostBinding, OnInit } from '@angular/core';
import { ThemeService } from '@icc/shared/helpers/b2b';
import { ActivatedRoute, ActivationEnd, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService, } from '@ngx-translate/core';
import { init, SyncService } from '@icc/b2b/sales-document';
import { State, scrollTop } from '@icc/b2b/shared';
import { Store } from '@ngrx/store';
import { ConfigService, UserBoxData } from '@icc/shared';
import { DateAdapter } from '@angular/material/core';
import { Panel } from '@icc/shared/types';
import { getDatefnsLocale } from '@icc/shared/helpers';

@Component({
    selector: 'icc-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'b2b';
    activePanel: Panel | null = null;
    userBoxData: UserBoxData;
    activatedRouteRootChildren!: ActivatedRoute[];
    activatedChildRoute!:ActivatedRoute;
    themeLogo! : string;
    themeSmallLogo! : string;
    favicon! : string;
    appVersion!: string;
    projectName!: string;
    @HostBinding('class.has-external-menu')
    hasExternalMenu = false;
    condensedUserMenu = false;

    constructor(
        private configService: ConfigService,
        private themeService: ThemeService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private syncService: SyncService,
        private store: Store<State>,
        private dateAdapter: DateAdapter<Date>,
    ) {}

    ngOnInit() {
        const appConfig = this.configService.config;
        this.store.dispatch(init());
        this.translate.addLangs([appConfig.languageCode]);
        this.translate.setDefaultLang(appConfig.languageCode);
        this.translate.use(appConfig.languageCode);
        this.dateAdapter.setLocale(getDatefnsLocale(appConfig.languageCode));
        this.activePanel = appConfig?.userData?.user?.ActivePanel as Panel;
        this.themeService.setTheme(appConfig.theme);
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.syncService.checkUser(appConfig?.userData?.user?.id);
            }
            if (event instanceof ActivationEnd) {
                if (event.snapshot.data.panel) {
                    this.activePanel = event.snapshot.data.panel;
                }
            }
            if (event instanceof NavigationEnd) {
                this.setActivatedRouteRootChildren();
            }
        });

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('redirect')) {
            this.router.navigate([searchParams.get('redirect').replace(/^\/b2b/, '')]);
        }


        this.userBoxData = appConfig?.userData?.user?.userBoxData;

        this.condensedUserMenu = appConfig?.theme?.condensed_user_menu;

        this.hasExternalMenu = appConfig?.env?.externalMenu && appConfig?.userData?.user?.id != null;

        if(appConfig?.companyTheme){
            this.themeLogo = appConfig.companyTheme?.logo_text ?
                '/files/companytheme/'+appConfig.companyTheme.logo_text :
                null;
            this.themeSmallLogo = appConfig.companyTheme?.small_logo ?
                '/files/companytheme/'+appConfig.companyTheme.small_logo :
                null;
            this.favicon = appConfig.companyTheme?.favicon ?
                '/files/companytheme/'+appConfig.companyTheme.favicon :
                null;

        }
        if(!this.themeLogo){
            this.themeLogo = appConfig?.domain?.theme_logo?
                '/files/domains/'+appConfig.domain.theme_logo :
                appConfig?.logo;
        }
        if(!this.themeSmallLogo){
            this.themeSmallLogo= appConfig?.domain?.theme_small_logo?
                '/files/domains/'+appConfig.domain.theme_small_logo :
                appConfig?.logo;
        }

        if(!this.favicon && appConfig?.domain?.theme_favicon){
            this.favicon ='/files/domains/'+appConfig.domain.theme_favicon;
        }

        this.setFavicon(this.favicon);


    }

    setFavicon(favicon:string){
        if(favicon){
            const b2bFavicon: HTMLLinkElement = document.querySelector('#b2bFavicon');
            b2bFavicon.href = favicon;
        }
    }

    activatedChild(event:any){

        if(event?.route){
            this.activatedChildRoute = event.route as ActivatedRoute;
            this.setActivatedRouteRootChildren();
        }else if(event?.activatedRoute){
            this.activatedChildRoute = event.activatedRoute as ActivatedRoute;
            this.setActivatedRouteRootChildren();
        }
        scrollTop();
    }

    setActivatedRouteRootChildren(){

        if(this.activatedRoute?.root?.children?.length){
            if(this.activatedChildRoute) {
                this.activatedRouteRootChildren = [].concat(this.activatedChildRoute, this.activatedRoute.root.children);
            }else{
                this.activatedRouteRootChildren = [... this.activatedRoute.root.children];
            }
        }

    }
}
